import { NgModule } from '@angular/core';
import { HttpClientModule } from '@angular/common/http';
import { TextMaskModule } from 'angular2-text-mask';

import { CommonComponentsModule } from './common-components/module';
import { CommonPipesModule } from './pipes/module';
import { BaseUpgradeModule } from './misc/base-upgrade.module';
import { PersonaSurveyModalModule } from './modals/persona-survey-modal/module';

const COMMON_MODULES = [
  HttpClientModule,
  TextMaskModule,
  CommonComponentsModule,
  CommonPipesModule,
  BaseUpgradeModule,
  PersonaSurveyModalModule,
];

@NgModule({
  exports: COMMON_MODULES,
})
export class CommonModule {}
